import { render } from "./UITextInput.vue?vue&type=template&id=2f19b081&scoped=true&ts=true"
import script from "./UITextInput.vue?vue&type=script&lang=ts"
export * from "./UITextInput.vue?vue&type=script&lang=ts"

import "./UITextInput.vue?vue&type=style&index=0&id=2f19b081&scoped=true&lang=css"

import exportComponent from "/root/app/github/pehuen-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f19b081"]])

export default __exports__